import { PersonDTO } from '@platform/ics-front-core';

export const getPersonFIO = (person: PersonDTO): string => {
    return `${person.lastName} ${person.firstName} ${person.middleName || ''}`.trim();
};
